import React from 'react';
import {render} from 'react-dom';
const TeamComponent = ({pic, title, text}) => (
  <section className="team-home-card column large-4 medium-expanded small-12">
    <article className="team-home-card__wrapper">
      <figure>
        <img src={pic} className="team-home-card__image" />
      </figure>
      <header className="row">
        <h3 className="text-center margin-bottom-default team-home-card__heading">{title}</h3>
      </header>
      <section className="text-justify team-home-card__content">
        <article>{text}</article>
      </section>
    </article>
  </section>
);
export default TeamComponent;



// WEBPACK FOOTER //
// ./src/components/TeamComponent.js